import React from 'react';

import { INTAKE_CONCERN } from '../utils/specialismMatch';
import { getConcernPathwayLabel } from '../utils/triagePathways';

/**
 * ConcernBadge
 * ------------
 * A small, colour-coded pill that makes a referral's pathway — ADHD, Autism, or
 * combined — visible at a glance wherever a referral is shown (TD-142). Renders
 * nothing when the concern is not yet classified, so an unclassified referral is
 * never mislabelled before its pathway is derived.
 */
const CONCERN_STYLES = {
  [INTAKE_CONCERN.ADHD]: 'bg-blue-100 text-blue-800 border-blue-200',
  [INTAKE_CONCERN.ASD]: 'bg-purple-100 text-purple-800 border-purple-200',
  [INTAKE_CONCERN.BOTH]: 'bg-indigo-100 text-indigo-800 border-indigo-200',
};

export default function ConcernBadge({ intakeConcern, className = '' }) {
  const key = String(intakeConcern || '').trim().toLowerCase();
  const label = getConcernPathwayLabel(key);
  if (!label) return null;

  const style = CONCERN_STYLES[key] || 'bg-gray-100 text-gray-600 border-gray-200';
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${style} ${className}`}
      title={`${label} referral`}
    >
      {label}
    </span>
  );
}
